import { createHmac } from 'crypto';

const allow_tracking = () => {
  if (!window.navigator.userAgent.match(/MSIE\s10\.0|trident\/6\.0/i)) {
    return (!(window.navigator.doNotTrack || window.navigator.msDoNotTrack));
  }
}

const connection_data = ({ connection }) => {
  const { downlink, effectiveType } = connection;
  return { connection_type: effectiveType, connection_link: downlink };
}

const browser_screen_details = ({ width, height, orientation, pixelDepth }) => ({
  cart_count: 0,
  checkout: '',
  screen_width: width,
  screen_height: height,
  screen_depth: pixelDepth,
  screen_orientation: orientation.type
});

const create_guid = () => {
  let guid = window.navigator.mimeTypes.length;
  guid += window.navigator.userAgent.replace(/\D+/g,'');
  guid += window.navigator.plugins.length;
  guid += window.screen.height || '';
  guid += window.screen.width || '';
  guid += window.screen.pixelDepth || '';
  return guid;
}

export default {

  track: allow_tracking,

  guid: () => {
    const guid = create_guid();
    const hash_key = `${Date.now()}`;
    return createHmac('sha1',hash_key).update(guid).digest('hex');
  },

  data: (id) => {

    const origin = window.location.origin;

    if (!allow_tracking()) return { cid: id, origin };

    const { language, platform } = window.navigator;

    const connection = connection_data(window.navigator);

    const screen_data = browser_screen_details(window.screen);

    return { cid: id, language, platform, origin, ...connection, ...screen_data }

  }

}
